import React from 'react';
import './BonusPromotion.css';

const BonusPromotion = () => {
  return (
 <div className="landing-container">
      {/* Header Section */}
      <div className="header-section-30">
        <h1 className="header-title">Stop letting fees<br />Eat your profits.</h1>

      </div>

      {/* Bonus Promo Section */}
      <div className="promo-section">
        <img
          src={require("../../../assets/Offer 4 Asset .png")}
          alt="Trader"
          className="promo-image"
        />
        <div className="promo-text">
          <h2>To Get 30% Cashback on
            Trading Costs!<br /> Real Cash Back in Your Pocket</h2>
          <p>
            At GivTrade, we believe active traders should be
            rewarded. When you open an account with $3,000 or
            more, you’ll receive %30 cashback on your trading
            fees — not as points or credits, but as real,
            withdrawable
          </p>
          <button className="claim-button" 
          onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/3'}>TURN YOUR TRADING COSTS INTO REWARDS</button>
        </div>
      </div>

      {/* Mid Section */}
      <div className="mid-section">
        <div className="strategy-text">
          <h3>But what if it paid
              you back?</h3>
          <p>Every trade costs you.</p>
        </div>
        <div className="smart-traders-box">
          <h3>GivTrade <br /> Gives you 30%</h3>
          <p>Of your spreads and commissions
              back in real money, because
              high-volume traders deserve more
              than just platform access.</p>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <h2>
          They deserve a financial edge.
        </h2>
        <div className="benefits-grid">
          <div className="benefits-column">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>%30 Cashback</strong><br />on spreads and commissions</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Real Money</strong><br />not points or locked credits</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>SFlexible Use</strong><br />withdraw or reinvest it</p>
            </div>
          </div>
          <div className="benefits-column2">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Boost Your Profitability</strong><br />with every trade</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Transparent Rewards</strong><br />with no hidden terms</p>
            </div>
          </div>
        </div>
      </div>

      {/* Final Call-to-Action Section */}
      <div className="final-cta-section">
        <h2>
         Minimum deposit: $3,000<br />
          <strong>Start earning cashback today</strong>
        </h2>
        <button className="cta-button" 
        onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/3'}>OPEN MY ACCOUNT NOW</button>
      </div>
    </div>
  );
};

export default BonusPromotion;